export default __webpack_public_path__ + "static/media/rqCalenderActive.22003f05.svg";